import React from 'react';
import EventMenu from '@apps/guest/packages/layout-engine/components/EventMenu/EventMenu';
import type { EventMenuProps } from '@apps/guest/packages/layout-engine/components/EventMenu/EventMenu.types';
import { useMobileTopBarNavMenu, useMobileTopBarNavOffset } from '@apps/guest/packages/layout-engine/components/MobileTopBarNav';

type TopBarNavEventMenuProps = EventMenuProps;

/**
 * Wrapper around EventMenu that sources the drawer's open-state from the shared
 * MobileTopBarNav context, so the sticky top-bar hamburger and the floating MenuButton
 * drive the same drawer. Used by both Aloha and Brannan (both render EventMenu). Must render
 * inside MobileTopBarNavOffsetProvider — every consuming layout wraps its tree in it. The
 * floating MenuButton is hidden whenever the sticky bar is visible (offset > 0), so the two
 * triggers never coexist.
 */
export const TopBarNavEventMenu: React.FC<TopBarNavEventMenuProps> = props => {
  const { isMenuOpen, openMenu, closeMenu } = useMobileTopBarNavMenu();
  const offset = useMobileTopBarNavOffset();

  return (
    <EventMenu
      {...props}
      isOpen={isMenuOpen}
      onOpen={openMenu}
      onClose={closeMenu}
      hideMenuButton={offset > 0}
    />
  );
};

TopBarNavEventMenu.displayName = 'TopBarNavEventMenu';

export default TopBarNavEventMenu;
